import React from 'react';
import { Icon } from '../../../components/ui';
import { usePhone } from '../PhoneContext';

/**
 * CallButton — click-to-call. Drop next to any phone number in the CRM
 * to make it dialable. Disabled (with a hint) when the phone isn't
 * registered, so it never silently no-ops.
 *
 *   <CallButton number={customer.phone} />
 */
export const CallButton: React.FC<{
  number: string | null | undefined;
  variant?: 'icon' | 'chip';
  className?: string;
}> = ({ number, variant = 'icon', className = '' }) => {
  const { startCall, registration, call } = usePhone();
  if (!number) return null;

  const disabled = registration !== 'registered' || !!call;
  const title = registration !== 'registered'
    ? 'הטלפון לא מחובר'
    : call ? 'שיחה כבר פעילה' : `התקשר ל-${number}`;

  const onClick = (e: React.MouseEvent) => {
    e.preventDefault(); e.stopPropagation();
    if (!disabled) startCall(number);
  };

  if (variant === 'chip') {
    return (
      <button
        onClick={onClick}
        disabled={disabled}
        title={title}
        className={`inline-flex items-center gap-1.5 rounded-lg bg-emerald-50 dark:bg-emerald-500/10 text-emerald-700 dark:text-emerald-300 hover:bg-emerald-100 disabled:opacity-40 px-2.5 py-1 text-xs font-semibold transition ${className}`}
      >
        <Icon name="call" size={14} /> התקשר
      </button>
    );
  }

  return (
    <button
      onClick={onClick}
      disabled={disabled}
      title={title}
      aria-label={title}
      className={`inline-flex items-center justify-center size-7 rounded-lg text-emerald-600 hover:bg-emerald-50 dark:hover:bg-emerald-500/10 disabled:opacity-30 disabled:hover:bg-transparent transition ${className}`}
    >
      <Icon name="call" size={16} />
    </button>
  );
};
